module.exports = __webpack_public_path__ + "static/media/stockhausen_held_3.54735552.png";